import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createQuote, fetchQuotes, deleteQuote } from "../../store/quote"
import Spinner from "../Spinner"
import QuoteDetails from "./QuoteDetails"
import "../styles/LeadQuoteList.css"

function LeadQuoteList({ leadId, onSelectQuote, selectedQuote }) {
  const dispatch = useDispatch()
  const quotes = useSelector((state) =>
    state.quotes.quotes.filter((quote) => quote.leadId === leadId)
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    dispatch(fetchQuotes(leadId)).finally(() => setLoading(false))
  }, [dispatch, leadId])

  const handleViewDetails = (quoteId) => {
    const quote = quotes.find((q) => q.id === quoteId)
    onSelectQuote(quote)
  }

  const handleDelete = async (quoteId) => {
    if (window.confirm("Are you SURE? You want to --DELETE-- this order?")) {
      try {
        await dispatch(deleteQuote(quoteId))
        await dispatch(fetchQuotes(leadId))
        console.log("Quote Deleted Successfully")
      } catch (error) {
        console.error("Error Deleting Quote:", error)
      }
    }
  }

  const handleCreateNewQuote = () => {
    onSelectQuote({ leadId, isNew: true })
  }

  if (loading) return <Spinner />

  return (
    <div className="lead-quote-list-container">
      <div className="lead-quote-list-header">
        <table>
          <thead>
            <tr>
              <th>LeadId</th>
              <th>Quote Number</th>
              <th>Date</th>
              <th>Description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((quote) => (
              <tr key={quote.id}>
                <td>{quote.leadId}</td>
                <td>{quote.quoteNumber}</td>
                <td>{quote.dated}</td>
                <td>{quote.description}</td>
                <td>{quote.status}</td>
                <td>
                  <div className="cat-container">
                    <button
                      className="detailsButton"
                      onClick={() => handleViewDetails(quote.id)}
                    >
                      Details
                    </button>
                    <button
                      className="delete-button"
                      onClick={() => handleDelete(quote.id)}
                    >
                      <svg className="delete-svgIcon" viewBox="0 0 448 512">
                        <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="create-new-quote-btn-container">
          <button
            onClick={handleCreateNewQuote}
            className="create-new-quote-btn"
          >
            Create New Quote
          </button>
        </div>
      </div>
      {selectedQuote && (
        <QuoteDetails
          quote={selectedQuote}
          onSave={(quoteData) => {
            if (quoteData.isNew) {
              dispatch(createQuote(quoteData))
            } else {
              dispatch(
                updateQuote({ id: quoteData.id, updatedData: quoteData })
              )
            }
            onSelectQuote(quoteData) // This line might need adjustment
            dispatch(fetchQuotes(leadId)) // Refetch quotes after update
          }}
          selectedLead={{ id: leadId }}
          hasQuote={!!selectedQuote?.id}
        />
      )}
    </div>
  )
}

export default LeadQuoteList
